import React from "react";
import NiceModal from "@ebay/nice-modal-react";
import {observer} from "mobx-react";
import {callWithCatch, tourneyUrl} from "../../utils";
import {NiceModalForm} from "../../components/Modals";
import {Form, Input} from "antd";
import FormSelector from "../../components/FormSelector";
import store from "./store";

export default NiceModal.create(observer(({t}) => {
  let onSave = async (params) => {
    await callWithCatch({
      url: tourneyUrl(`/t/${t.id}`),
      params,
      method: 'post',
      onSuccess: () => {
        store.triggerRefresh('reg_change');
        NiceModal.remove();
      }
    });
  }

  return <NiceModalForm width={250} onSave={onSave} title="Edit Team" okText="Save" initialValues={{name: t.name, cap_name: t.captain}}>
    <Form.Item name="name" label="Team Name" rules={[{required: true, message: "Required"}]}>
      <Input style={{width: "100%"}} autoFocus placeholder="e.g. Super Dinkers"/>
    </Form.Item>
    <FormSelector width="200px" label="Captain" name="cap_name" options={t.players.map(pl => [pl.name, pl.name])} />
  </NiceModalForm>
}));

